import React, { useRef } from 'react'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useMemoryBook } from '../../../../../providers/MemoryBookProvider'

export default function CaptionOverlay({
  overlay,
  pageNumber,
  positionIndex,
  captionState = '',
  textFieldOnChange,
  titleState = '',
  titleFieldOnChange,
  isHeading = false,
  titleText,
  customLayoutElementId,
  onUpdateCustomLayoutElementData,
  maxLength,
}) {
  const [t] = useTranslation()
  const { updatePageContent } = useMemoryBook() || {}

  const isCustomLayoutElement = Boolean(customLayoutElementId && onUpdateCustomLayoutElementData)

  const saveOnclick = async () => {
    if (isCustomLayoutElement) {
      await onUpdateCustomLayoutElementData({
        caption: captionState,
        title: titleState,
        isPlaceholder: undefined,
      })
    } else {
      await updatePageContent(pageNumber, positionIndex, {
        caption: captionState,
        title: titleState,
      })
    }
    overlay.close()
  }
  const textRef = useRef()

  const defaultMaxLength = !isHeading ? 70 : 50
  const effectiveMaxLength = maxLength ?? defaultMaxLength

  return (
    <DialogOverlay title={titleText} {...overlay} focusRef={textRef}>
      <TextField
        label={isHeading ? t('CaptionOverlay.title.label', 'Title') : t('CaptionOverlay.caption.label', 'Caption')}
        value={isHeading ? titleState : captionState}
        onChange={isHeading ? titleFieldOnChange : textFieldOnChange}
        maxLength={effectiveMaxLength}
        ref={textRef}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            saveOnclick()
          }
        }}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={overlay.close}>{t('common-ui:cancel.action', 'Cancel')}</Button>
          <Button onClick={saveOnclick} type="submit" emphasis="high">
            {t('common-ui:save.action', 'Save')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
